<template>
  <div class="datetime-formatter mb-1">
    <div class="field-container mr-1">
      <text-field
        id="format-field"
        label="Format"
        placeholder="E.g.: dd/MM/yyyy"
        v-model="format"
      />
    </div>
    <div class="buttons">
      <button
        class="btn btn-primary"
        type="button"
        :disabled="!format"
        @click="resolveClicked"
      >
        Resolve
      </button>
      <help-link page="date-time-formats" />
    </div>
  </div>
</template>
<script>
import HelpLink from "@/components/common/help/HelpLink.vue";

export default {
  components: { HelpLink },
  props: {
    field: {
      required: true,
    },
  },
  data: function() {
    return {
      format: "",
    };
  },
  computed: {
    query: function() {
      return this.field.value.queries.find(
        (q) => q.query.name === "query.dateTimeFormat"
      );
    },
  },
  methods: {
    resolveClicked: function() {
      this.logDebug("Resolving date/time format.", {
        args: {
          format: this.format,
        },
        fieldQueryName: this.query.name,
      });
      
      this.$emit("resolve", {
        args: {
          format: this.format,
        },
        fieldQueryName: this.query.name,
      });
    },
  },
  emits: ["resolve"],
};
</script>
<style lang="scss" scoped>
.datetime-formatter {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > .field-container {
    flex-grow: 1;
  }

  & > .buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
